/* eslint-disable */
import React, { useMemo, useState } from "react";
import { sendBroadcast } from "../../services/broadcastService";

export default function AdminBroadcastModal({ schoolId, onClose }) {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [audience, setAudience] = useState("all");
  const [category, setCategory] = useState("school_update");
  const [classId, setClassId] = useState("");
  const [recipients, setRecipients] = useState("");
  const [pinned, setPinned] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const [resultMsg, setResultMsg] = useState("");

  const canSubmit = useMemo(() => {
    if (!title.trim() || !message.trim()) return false;
    if (audience === "class" && !classId.trim()) return false;
    if (audience === "selected" && !recipients.trim()) return false;
    return true;
  }, [title, message, audience, classId, recipients]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!canSubmit || sending) return;

    setSending(true);
    setError("");
    setResultMsg("");

    try {
      const data = await sendBroadcast({
        schoolId,
        title: title.trim(),
        message: message.trim(),
        audience,
        category,
        notificationCategory: category,
        parentCategory: category,
        module: category,
        type: category,
        classId: audience === "class" ? classId.trim() : null,
        recipients:
          audience === "selected"
            ? recipients
                .split(",")
                .map((v) => v.trim())
                .filter(Boolean)
            : [],
        pinned: Boolean(pinned),
isPinned: Boolean(pinned),
pinToFeed: Boolean(pinned),
pinToParentFeed: Boolean(pinned),
pinnedInParentFeed: Boolean(pinned),
pinnedToParentFeed: Boolean(pinned),
parentPinned: Boolean(pinned),
pinThisUpdate: Boolean(pinned),
      });

      setResultMsg(
        `Sent successfully. Parents matched: ${
          data?.matchedUsersCount ?? data?.recipientsCount ?? 0
        }. Push sent: ${data?.successCount ?? 0}.`
      );

      setTitle("");
      setMessage("");
      setClassId("");
      setRecipients("");
      setPinned(false);
      setAudience("all");
      setCategory("school_update");
    } catch (err) {
      console.error("Broadcast send failed:", err);
      setError(
        err?.message || "Broadcast could not be sent. Please try again."
      );
    } finally {
      setSending(false);
    }
  }

  return (
    <div style={backdropStyle} onClick={onClose}>
      <div style={cardStyle} onClick={(e) => e.stopPropagation()}>
        <div style={topRowStyle}>
          <div>
            <div style={eyebrowStyle}>PresentPlus Admin</div>
            <h3 style={titleStyle}>Send Broadcast</h3>
          </div>

          <button type="button" onClick={onClose} style={closeBtnStyle}>
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} style={formStyle}>
          <label style={labelStyle}>
            <span style={labelTextStyle}>Title</span>
            <input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Important school update"
              style={inputStyle}
              maxLength={120}
              required
            />
          </label>

          <label style={labelStyle}>
            <span style={labelTextStyle}>Message</span>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Write the broadcast message for parents..."
              rows={5}
              style={textareaStyle}
              required
            />
          </label>

          <label style={labelStyle}>
            <span style={labelTextStyle}>Category</span>
            <select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              style={inputStyle}
            >
              <option value="school_update">School update</option>
              <option value="attendance">Attendance</option>
              <option value="behaviour">Behaviour</option>
              <option value="reports">Reports</option>
            </select>
          </label>

          <label style={labelStyle}>
            <span style={labelTextStyle}>Audience</span>
            <select
              value={audience}
              onChange={(e) => setAudience(e.target.value)}
              style={inputStyle}
            >
              <option value="all">All parents</option>
              <option value="class">Specific class</option>
<option value="selected">Selected parents</option>
            </select>
          </label>

          {audience === "class" ? (
            <label style={labelStyle}>
              <span style={labelTextStyle}>Class / Year</span>
              <input
                value={classId}
                onChange={(e) => setClassId(e.target.value)}
                placeholder="e.g. Year 4"
                style={inputStyle}
                required
              />
            </label>
          ) : null}

          {audience === "selected" ? (
            <label style={labelStyle}>
              <span style={labelTextStyle}>Recipient Parent IDs</span>
              <textarea
                value={recipients}
                onChange={(e) => setRecipients(e.target.value)}
                placeholder="Comma-separated parent IDs"
                rows={3}
                style={textareaStyle}
                required
              />
            </label>
          ) : null}

          <label style={checkboxRowStyle}>
            <input
              type="checkbox"
              checked={pinned}
              onChange={(e) => setPinned(e.target.checked)}
            />
            <span>Pin this update in the parent feed</span>
          </label>

          {error ? <div style={errorStyle}>{error}</div> : null}
          {resultMsg ? <div style={successStyle}>{resultMsg}</div> : null}

          <div style={actionsStyle}>
            <button type="button" onClick={onClose} style={secondaryBtnStyle}>
              Close
            </button>

            <button
              type="submit"
              disabled={!canSubmit || sending}
              style={{
                ...primaryBtnStyle,
                opacity: !canSubmit || sending ? 0.6 : 1,
                cursor: !canSubmit || sending ? "not-allowed" : "pointer",
              }}
            >
              {sending ? "Sending..." : "Send Broadcast"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const backdropStyle = {
  position: "fixed",
  inset: 0,
  zIndex: 2000,
  background: "rgba(10, 16, 31, 0.34)",
  backdropFilter: "blur(8px)",
  WebkitBackdropFilter: "blur(8px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 18,
};

const cardStyle = {
  width: "100%",
  maxWidth: 640,
  borderRadius: 28,
  background: "rgba(255,255,255,0.94)",
  border: "1px solid rgba(255,255,255,0.6)",
  boxShadow:
    "0 24px 60px rgba(24,39,75,0.18), inset 0 1px 0 rgba(255,255,255,0.65)",
  padding: 22,
};

const topRowStyle = {
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "space-between",
  gap: 12,
  marginBottom: 18,
};

const eyebrowStyle = {
  fontSize: 12,
  fontWeight: 800,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: "#7b86a8",
  marginBottom: 6,
};

const titleStyle = {
  margin: 0,
  fontSize: 28,
  fontWeight: 900,
  color: "#171c3a",
};

const closeBtnStyle = {
  width: 42,
  height: 42,
  borderRadius: 14,
  border: "1px solid rgba(23,28,58,0.06)",
  background: "rgba(255,255,255,0.72)",
  color: "#4c5676",
  fontSize: 18,
  fontWeight: 800,
  cursor: "pointer",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  lineHeight: 1,
  padding: 0,
};

const formStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 14,
};

const labelStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 8,
};

const labelTextStyle = {
  fontSize: 13,
  fontWeight: 800,
  color: "#44506f",
};

const inputStyle = {
  minHeight: 50,
  borderRadius: 16,
  border: "1px solid rgba(23,28,58,0.08)",
  background: "#fff",
  padding: "0 14px",
  fontSize: 15,
  color: "#171c3a",
  outline: "none",
};

const textareaStyle = {
  minHeight: 110,
  borderRadius: 16,
  border: "1px solid rgba(23,28,58,0.08)",
  background: "#fff",
  padding: "14px",
  fontSize: 15,
  color: "#171c3a",
  outline: "none",
  resize: "vertical",
  fontFamily: "inherit",
};

const checkboxRowStyle = {
  display: "flex",
  alignItems: "center",
  gap: 10,
  color: "#4c5676",
  fontSize: 14,
  fontWeight: 700,
};

const actionsStyle = {
  display: "flex",
  justifyContent: "flex-end",
  gap: 10,
  marginTop: 6,
};

const secondaryBtnStyle = {
  minHeight: 48,
  borderRadius: 16,
  border: "1px solid rgba(23,28,58,0.08)",
  background: "rgba(255,255,255,0.72)",
  color: "#4c5676",
  padding: "0 18px",
  fontSize: 14,
  fontWeight: 800,
  cursor: "pointer",
};

const primaryBtnStyle = {
  minHeight: 48,
  borderRadius: 16,
  border: "none",
  background: "linear-gradient(180deg, #5a66ff 0%, #4c57ff 100%)",
  color: "#fff",
  padding: "0 18px",
  fontSize: 14,
  fontWeight: 800,
  boxShadow: "0 10px 18px rgba(76,87,255,0.20)",
};

const errorStyle = {
  borderRadius: 14,
  background: "rgba(255, 87, 87, 0.10)",
  color: "#b3261e",
  padding: "12px 14px",
  fontSize: 14,
  fontWeight: 700,
};

const successStyle = {
  borderRadius: 14,
  background: "rgba(31, 181, 84, 0.10)",
  color: "#148a42",
  padding: "12px 14px",
  fontSize: 14,
  fontWeight: 700,
};